import { useState } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: 'Sophie L.',
      age: 32,
      city: 'Bruxelles',
      rating: 5,
      text: 'Incroyable ! Ma peau n\'a jamais été aussi lumineuse. Les points noirs ont complètement disparu après seulement 2 semaines d\'utilisation. Je recommande à 100% !',
      treatment: 'Exfoliant au riz blanc coréen + Exfoliant au riz noir coréen',
      date: 'Il y a 2 semaines'
    },
    {
      id: 2,
      name: 'Marie D.',
      age: 28,
      city: 'Liège',
      rating: 5,
      text: 'J\'avais des doutes au début, mais les résultats sont là ! Ma peau est plus douce, plus hydratée et mon teint est unifié. Un vrai miracle pour ma peau sensible.',
      treatment: 'Hydratation Intense',
      date: 'Il y a 1 mois'
    },
    {
      id: 3,
      name: 'Laura V.',
      age: 35,
      city: 'Anvers',
      rating: 5,
      text: 'Après avoir essayé des dizaines de produits, j\'ai enfin trouvé LA solution. Mes pores sont resserrés et ma peau respire. Je ne peux plus m\'en passer !',
      treatment: 'Ampoule à l\'ADN de saumon coréen',
      date: 'Il y a 3 semaines'
    },
    {
      id: 4,
      name: 'Emma B.',
      age: 29,
      city: 'Gand',
      rating: 5,
      text: 'Une vraie transformation ! Ma peau était terne et fatiguée, maintenant elle est éclatante et repulpée. Tous mes collègues me demandent mon secret.',
      treatment: 'Masque Biodance hydrogel coréen',
      date: 'Il y a 2 mois'
    },
    {
      id: 5,
      name: 'Chloé M.',
      age: 31,
      city: 'Charleroi',
      rating: 5,
      text: 'Le meilleur investissement beauté que j\'ai fait ! Les résultats sont visibles dès la première application. Ma peau est transformée et je me sens tellement plus confiante.',
      treatment: 'Toutes les Peaux',
      date: 'Il y a 1 semaine'
    },
    {
      id: 6,
      name: 'Amélie R.',
      age: 27,
      city: 'Namur',
      rating: 5,
      text: 'Enfin des produits qui tiennent leurs promesses ! Ma peau est plus lisse, plus ferme et les imperfections ont disparu. Je suis absolument ravie du résultat.',
      treatment: 'Exfoliant au riz blanc coréen',
      date: 'Il y a 3 semaines'
    }
  ];

  const itemsPerPage = 3;
  const totalPages = Math.ceil(testimonials.length / itemsPerPage);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % totalPages);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + totalPages) % totalPages);
  };

  const visibleTestimonials = testimonials.slice(
    currentIndex * itemsPerPage,
    (currentIndex + 1) * itemsPerPage
  );

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-12 max-w-7xl">
        {/* Titre section */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-light text-gray-900 mb-4">
            Ce qu'elles en disent
          </h2>
          <p className="text-lg text-gray-600">
            Des milliers de clientes satisfaites partagent leur expérience
          </p>
        </div>

        {/* Carrousel témoignages */}
        <div className="relative">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {visibleTestimonials.map((testimonial) => (
              <div key={testimonial.id} className="bg-[#FAF9F7] rounded-2xl p-8">
                {/* Header avec avatar et infos */}
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#E8B4A8] to-[#D4A29A] flex items-center justify-center text-white text-xl font-semibold flex-shrink-0">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-gray-900">
                      {testimonial.name}, {testimonial.age} ans
                    </h3>
                    <p className="text-sm text-gray-500">{testimonial.city}</p>
                  </div>
                </div>

                {/* Étoiles */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-[#E8B4A8] text-lg"></i>
                  ))}
                </div>

                {/* Témoignage */}
                <p className="text-sm text-gray-700 leading-relaxed mb-6">
                  "{testimonial.text}"
                </p>

                {/* Footer */}
                <div className="pt-4 border-t border-gray-200">
                  <p className="text-xs font-medium text-gray-900 mb-1">{testimonial.treatment}</p>
                  <p className="text-xs text-gray-500">{testimonial.date}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-4">
            <button
              onClick={prevSlide}
              className="w-12 h-12 rounded-full border-2 border-gray-300 flex items-center justify-center hover:border-[#E8B4A8] hover:text-[#E8B4A8] transition-all duration-300 cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-2xl"></i>
            </button>

            {/* Indicateurs */}
            <div className="flex gap-2">
              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                    index === currentIndex ? 'bg-[#E8B4A8] w-8' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>

            <button
              onClick={nextSlide}
              className="w-12 h-12 rounded-full border-2 border-gray-300 flex items-center justify-center hover:border-[#E8B4A8] hover:text-[#E8B4A8] transition-all duration-300 cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-2xl"></i>
            </button>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-8 mt-16 pt-16 border-t border-gray-200">
          <div className="text-center">
            <div className="text-4xl font-bold text-gray-900 mb-2">98%</div>
            <div className="text-sm text-gray-600">Clientes satisfaites</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-gray-900 mb-2">4.9/5</div>
            <div className="text-sm text-gray-600">Note moyenne</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-gray-900 mb-2">2500+</div>
            <div className="text-sm text-gray-600">Avis vérifiés</div>
          </div>
        </div>
      </div>
    </section>
  );
}
